import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button, Form, Input } from 'antd';

import clientActions from '../../../client/actions';
import CLIENT from '../../../client/actionTypes';

import { AppDispatch } from '../../../../types/app';

type FormValues = {
  Email: string;
};

type Props = {
  readyStatus: string;
  email?: string;
};

const FormSendCode = ({ readyStatus, email }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  const dispatch = useDispatch<AppDispatch>();

  const onSubmit = ({ Email }: FormValues) => {
    dispatch(
      clientActions.RecoveryPassword.sendCode(
        Email.toLowerCase().trim(),
        'auth'
      )
    );
  };

  const isRequesting =
    readyStatus === CLIENT.RECOVERY_PASSWORD.SEND_CODE.REQUESTING;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      disabled={isRequesting}
      initialValues={{
        Email: email || '',
      }}
    >
      <Form.Item
        name="Email"
        label={intl.formatMessage({ id: 'profile.field.Email' })}
        rules={[
          { required: true },
          {
            type: 'email',
            message: intl.formatMessage({ id: 'error.isEmail' }),
          },
        ]}
        normalize={(value) => value.trim().toLowerCase()}
      >
        <Input disabled={!!email} />
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={isRequesting}>
        {intl.formatMessage({ id: 'buttons.submit' })}
      </Button>
    </Form>
  );
};

export default FormSendCode;
